export const testimonialRelations = `{
  'profile_img_url': profile_img.asset->url,
  ...
}
`
